import PropTypes from 'prop-types';
import MenuSelectorGroup from '$src/components/MenuSelectorGroup';
import ActionCell from '$src/components/ActionCell';
import selectIcon from '$src/utils/selectIcon';
import { GENERAL_INFORMATION_URL } from '$src/constants/urls';
import { ONVIF_DEVICE_TYPE, E2EE_DEVICE_TYPE, ASTRO_ELEGIBLE_INFO, ASTRO_DEVICE_INTERNAL_TYPE, RECORDING_24X7_DEVICE_TYPE } from '$src/utils/devices/constants';
import { isAstro } from '$src/utils/devices/selectDevices';

const notEligibleMessage = (deviceType) => {
  const message = {
    indoor:
      // eslint-disable-next-line max-len
      'Indoor Cameras are not supported at this time. Please update this device’s General Settings in the Ring app if this device is being used outdoors.',
    battery: (
      <>
        This device is not currently supported for Virtual Security Guard. For a list of eligible devices,{' '}
        <a href={GENERAL_INFORMATION_URL} target="_blank" rel="noreferrer">
          click here.
        </a>
      </>
    ),
    solar: 'This device is not supported due to being solar powered. Please enroll a different device that is not solar powered.',
    [E2EE_DEVICE_TYPE]:
      // eslint-disable-next-line max-len
      'Guards can’t access cameras enrolled in End-to-End Encryption. Unenroll End-to-End Encryption in the Ring app to make this device eligible.',
    [RECORDING_24X7_DEVICE_TYPE]: (
      <>
      Devices in 24/7 recording mode are not supported. Switch to motion-based recording to use this device with Virtual Security Guard. Learn more {' '}
      <a href={GENERAL_INFORMATION_URL} target="_blank" rel="noreferrer">
         here.
      </a>
    </>
    ),
    [ASTRO_ELEGIBLE_INFO]: 'An active Astro Secure subscription is required to use Virtual Security Guard with this device.',
    default: 'This device is ineligible',
  };

  return message[deviceType] || message.default;
};

const getDescription = (device, notEligible) => {
  let message;
  const isOnVif = device.type === ONVIF_DEVICE_TYPE;

  if (notEligible) {
    return notEligibleMessage(device.starkEligibleInfo);
  }

  if (device.privacyZonesEnabled) {
    message = "This device has Privacy Zones set up. Rapid Response's Monitoring Specialists can't monitor areas blocked by Privacy Zones.\n";
  }

  if (isOnVif) {
    message =
      'ONVIF-compatible cameras are not made by Ring, and Ring does not support Two-Way Talk or sirens with these devices. You are solely responsible for this device’s suitability and security.';
  }

  return message;
};
function DeviceSection({ title, subTitle, children, data, type, deviceCheck, handleChange, notEligible, ...props }) {
  const order = (deviceA, deviceB) => deviceA.name.localeCompare(deviceB.name);

  return (
    <MenuSelectorGroup title={title} subTitle={subTitle} data-testid={props['data-testid']}>
      {children}
      {data.sort(order).map((device) => (
        <ActionCell
          className="device-list__item"
          iconName={selectIcon(isAstro(device) ? ASTRO_DEVICE_INTERNAL_TYPE : device.type)}
          onChange={() => handleChange(!device.starkEnrolled, device.doorbotId)}
          type={type}
          value={!!device.starkEnrolled}
          loading={device.doorbotId === deviceCheck}
          id={device.doorbotId}
          key={device.doorbotId}
          isDescriptionError={notEligible}
          description={getDescription(device, notEligible)}
          hasBlueWarning={device.type === ONVIF_DEVICE_TYPE || device.privacyZonesEnabled}
        >
          {device.name}
        </ActionCell>
      ))}
    </MenuSelectorGroup>
  );
}

DeviceSection.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.node,
  children: PropTypes.node,
  data: PropTypes.array,
  type: PropTypes.string,
  deviceCheck: PropTypes.number,
  handleChange: PropTypes.func,
  notEligible: PropTypes.bool,
  'data-testid': PropTypes.string,
};

export default DeviceSection;
